const utils = {
	storage_string: {
		conversion_failed: "Conversion from bytes failed",
	},
};

export default utils;
